import axios from 'axios'
import { host } from "./../host"
import { rememberToken, getValidToken } from './token'

const useAxios = axios.create({
  baseURL: host
})

export function setToken(token) {
  rememberToken(token)
  if (token) {
    useAxios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  } else {
    delete useAxios.defaults.headers.common['Authorization']
  }
}

// Re-validate the token before every request so an expired token is never sent
useAxios.interceptors.request.use(
  (config) => {
    const token = getValidToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    } else {
      delete config.headers['Authorization']
    }
    return config
  },
  (error) => Promise.reject(error)
)

// On 401, clear the stale session and redirect to login
useAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const hadSession = !!localStorage.getItem('user')
      setToken(null)
      if (hadSession) {
        window.location.replace('/accounts?q=login')
      }
    }
    return Promise.reject(error)
  }
)

setToken(getValidToken())

export default useAxios
